import { fetchRegionMetaCached } from '../../services/fetchRegionMeta';
import { TThunkAction } from '../../types/redux';
import { IRegion } from '../../types/regions';
import { setRegionCookies } from '../../utils/geo';
import { setError, setLoading } from '../appStatus';

export const requestCurrentRegion =
  (newCurrentRegion: IRegion): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    try {
      dispatch(setLoading(true));

      const regionMeta = await fetchRegionMetaCached(context, { locationId: newCurrentRegion.id });

      if (!regionMeta) {
        throw new Error('Failed to set current region');
      }

      const { id, baseHost, mainTownId } = regionMeta;

      setRegionCookies(id, mainTownId);

      if (!baseHost) {
        throw new Error(`No base host for region ${id}`);
      }

      // Перезагружаем всегда, чтобы ссылки в шапке обновились.
      window.location.href = `${baseHost}${window.location.pathname}${window.location.search}`;
    } catch (error) {
      context.logger.error(error, {
        comment: 'Ошибка при установке нового текущего региона.',
      });

      dispatch(setError('Что-то пошло не так. Пожалуйста, попробуйте еще раз.'));
    } finally {
      dispatch(setLoading(false));
    }
  };
